import { Table } from "reactstrap";
import { formatDate, formatPrice } from "../../../utils/helper/helpers";
type Items = { [key: string]: any };

const TableauShowLaffrage = ({ table, versements }: { table: Items[], versements: Items }) => {


    return (
        <Table bordered responsive className="text-center">
            <thead>
                <tr className="f-17">
                    <th scope="col">DATE PAIEMENT</th>
                    <th scope="col">TYPE DE MATERIEL</th>
                    <th scope="col">QUANTITE TONNE</th>
                    <th scope="col">QUANTITE SAC</th>
                    <th scope="col">MONTANT</th>
                </tr>
            </thead>
            <tbody>
                {table.map((item, index) => (
                    <tr className="f-17" key={item.id || index}>
                        {index === 0 && (
                            <td rowSpan={table.length} className="text-capitalize fw-bold">
                                {formatDate(versements?.pv_date_paiement)}
                            </td>
                        )}
                        <td className="text-capitalize">{item.materiel}</td>
                        <td>{parseInt(item.quantite_tonne, 10).toLocaleString("gn-GN")} Tonnes</td>
                        <td>{(Math.round(item.quantite_tonne * 20)).toLocaleString("gn-GN")} Sacs</td>
                        {index === 0 && (
                            <td rowSpan={table.length} className="fw-bold">
                                {/* <div> */}

                                {
                                    versements?.status === 'Attente' ? (
                                        <>
                                            <p className="bg-light-success">PLAFOND : <span className="text-uppercase fw-bold">{formatPrice(versements?.montant)}</span> </p>
                                            <p className="bg-light-danger my-1">UTILISÉ : <span className="text-uppercase fw-bold">{formatPrice(versements?.mt_update)}</span> </p>
                                            <p className="bg-light-info">RESTE A UTILISÉ: <span className="text-uppercase fw-bold">{formatPrice(versements?.montant - versements?.mt_update)}</span></p>
                                        </>
                                    ) : (
                                        <>
                                            <p className="bg-light-success">PAYÉ : <span className="text-uppercase fw-bold">{formatPrice(versements?.montant)}</span> </p>
                                            <p className="bg-light-danger my-1">UTILISÉ : <span className="text-uppercase fw-bold">{formatPrice(versements?.mt_update)}</span> </p>
                                        </>
                                    )
                                }
                                {/* </div> */}

                            </td>
                        )}
                    </tr>

                ))}
            </tbody>
        </Table>
    )
}

export default TableauShowLaffrage;